import '../styles/main.scss';

import { graphql } from 'gatsby';
import React from 'react';

import groq from 'groq';
import { useTranslation } from 'react-i18next';
import { Module } from '../components/ModulesContent';
import { HeroType } from '../components/ui/Hero';
import { ALL_LANGS } from '../constants';
import { LocalizedSEO } from '../graphql-fragments/seo';
import { withPagePreview } from '../preview/previewUtils';
import { withI18n } from '../utils/hocs';
import { localize } from '../utils/sanity';
import PageTemplate from './PageTemplate';

export const query = graphql`
  query GetPageById($id: String!) {
    sanityPage(_id: { eq: $id }) {
      title {
        ...LocaleStringFragment
      }
      slug {
        current
      }
      hero {
        ...Hero
      }
      modules {
        ...Modules
      }
      hideFormModule
      seo {
        ...SEO
      }
    }
  }
`;

const groqQuery = groq`{
  "sanityPage": *[_id == $id][0] {
     ...
  }
}`;

export type ModuleBgColor = 'white' | 'colored';
export type BackgroundColorTheme = '#E5F8E8' | '#EFECFA';

interface LocalizedQueryData {
  sanityPage: {
    title: string;
    slug: {
      current: string;
    };
    hero: HeroType;
    modules?: Array<Module>;
    hideFormModule?: boolean;
    seo?: LocalizedSEO;
  };
}

const Page = withPagePreview<LocalizedQueryData>(
  {
    groqQuery,
  },
  ({ data }): React.ReactElement => {
    const { i18n, t } = useTranslation();

    const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
    const localizedData: LocalizedQueryData = localize(data, langs);

    return (
      <PageTemplate
        page={localizedData.sanityPage}
        defaultSEO={{
          defaultTitle: localizedData.sanityPage.title,
        }}
      />
    );
  },
);

export default withI18n(Page);
